import React, { createContext, useReducer } from "react";
import ModalEventHandler from "../components/Modals/ModalEventHandler";
import ModalActionEnum from "../components/Modals/BaseModal/ModalActionEnum";

export const ModalContext = createContext(null);

interface IModalState {
    modal: string;
}

interface IModalAction {
    type: ModalActionEnum
    modal: string;
}

const modalReducer = (state: IModalState, action: IModalAction) => {
    switch (action.type) {
        case ModalActionEnum.Type: return {
            ...state,
            modal: action.modal
        };
        default: return state;
    }
};

export interface IModalProviderProps {
    headerHeight: number;
    children?;
}

export const ModalProvider = (props: IModalProviderProps) => {
    const { headerHeight } = props;
    const [currentModal, dispatch]: [IModalState, (IModalAction) => void] = useReducer(modalReducer, { modal: null });
    const openModal = (modalId) => dispatch({ type: ModalActionEnum.Type, modal: modalId });
    const closeModals = () => dispatch({ type: ModalActionEnum.Type, modal: null });
    return (
        <ModalContext.Provider value={{currentModal, dispatch, headerHeight, openModal, closeModals}}>
            <ModalEventHandler>
                {props.children}
            </ModalEventHandler>
        </ModalContext.Provider>
    );
};

export default ModalContext;